import React, { useState } from "react";
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { toast } from "react-toastify";
import {
  TOAST_UPLOAD_PARTIAL,
  BTN_VIEW_FAILED_DOMAINS,
  FAILED_DOMAINS_DIALOG_TITLE,
  BTN_CLOSE,
} from "./constants/manageWhitelistDomainText";
import { manageWhitelistDomainStyles } from "./constants/manageWhitelistDomainStyles";

// Toast content shown when an upload partially fails; failed domains are revealed on demand via a dialog.
const FailedDomainsToast = ({ toastId, successCount, failedCount, failedDomains = [] }) => {
  const [open, setOpen] = useState(false);

  const handleView = (event) => {
    event.stopPropagation();
    setOpen(true);
  };

  const handleClose = (event) => {
    event?.stopPropagation();
    setOpen(false);
    // dismiss the toast once the user has seen the failed domains
    toast.dismiss(toastId);
  };


  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 0.75 }}>
      <Box>{TOAST_UPLOAD_PARTIAL(successCount, failedCount)}</Box>

      {failedDomains.length > 0 && (
        <Button
          size="small"
          variant="outlined"
          onClick={handleView}
          sx={{ ...manageWhitelistDomainStyles.uploadButton, minWidth: 0, px: 1, py: 0.25, fontSize: 12 }}
        >
          {BTN_VIEW_FAILED_DOMAINS}
        </Button>
      )}

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>{FAILED_DOMAINS_DIALOG_TITLE}</DialogTitle>
        <DialogContent dividers>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
              maxHeight: 132,
              overflowY: "auto",
            }}
          >
            {failedDomains.map((domain) => (
              <Chip key={domain} label={domain} size="small" variant="outlined" />
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{BTN_CLOSE}</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default FailedDomainsToast;
